import round from 'lodash/round'

import { normalizeMoney, serializeMoney } from '@/lib/adapters/common.adapter'
import type {
  CostValue,
  GroupedTrafficSourceCostType,
  TrafficSourceCostServerType,
} from '@/types/trafficSourceCost'

export const defaultTrafficSourceGroup = {
  cpc: null,
  cpa: null,
  sourceIndexes: [],
  rateCpc: 0,
  rateCpa: 0,
}

export const normalizeTrafficSourceCosts = (
  trafficSourceCosts: TrafficSourceCostServerType[] = [],
): GroupedTrafficSourceCostType[] => {
  const groups: GroupedTrafficSourceCostType[] = []

  trafficSourceCosts.forEach((item) => {
    const cpc = item.cpc_v2 ? normalizeMoney(item.cpc_v2) : null
    const cpcInMajor = cpc ? cpc.amount : 0
    const cpcInMinor = cpcInMajor * 100

    // Combine traffic sources by their values
    const group = groups.find((group) => group.cpa === item.cpa && group.cpc === cpcInMinor)

    if (group) {
      group.sourceIndexes.push(item.source)
    } else {
      groups.push({
        cpa: item.cpa,
        cpc: cpcInMinor,
        rateCpc: cpcInMajor,
        rateCpa: round(item.cpa * 100),
        sourceIndexes: [item.source],
      })
    }
  })

  return groups
}

export const isEmptyValue = (value: CostValue) =>
  value === undefined || value === null || value === ''

const hasCostValue = (data: GroupedTrafficSourceCostType) => {
  return !isEmptyValue(data.rateCpc) || !isEmptyValue(data.rateCpa)
}

export const serializeTrafficSourceCosts = (
  group: GroupedTrafficSourceCostType[],
  currencyCode: string,
): TrafficSourceCostServerType[] => {
  const trafficSourceCosts: TrafficSourceCostServerType[] = []

  group.forEach((item) => {
    if (hasCostValue(item)) {
      item.sourceIndexes.forEach((sourceIndex) => {
        trafficSourceCosts.push({
          source: sourceIndex,
          cpa: item.rateCpa ? round(Number(item.rateCpa) / 100, 6) : 0,
          // @ts-expect-error todo fix me
          cpc: item.rateCpc ? round(Number(item.rateCpc) * 100) : 0,
          // @ts-expect-error todo fix me
          cpc_v2: serializeMoney({ amount: item.rateCpc ?? 0, currency: currencyCode }),
        })
      })
    }
  })

  return trafficSourceCosts
}
